export default __webpack_public_path__ + "static/media/buy_gmx.66dc1de7.svg";